import React, {Component} from 'react';
import {
  ALL_SEARCH_CATEGORY_GET_SIZE,
  ALL_SEARCH_GET_SIZE,
  emptyCountAllSearchResult,
  ICountAllSearchResult,
  IFileSearchResultItem,
  INewCategorySearchResultItem,
  IPostSearchResultItem,
  ISearchTabIndices,
  SearchRepository2,
} from "repositories/SearchRepository2";
import {LanguageService} from "language/LanguageService";
import {SsqDataRepository} from "repositories/SsqDataRepository";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {SsqImages} from "images/SsqImages";
import {ErrorpageWrap, TabItem, TitleBarContainer, TitleBarContents, TitleBarItem} from "style/CommonStyledComponents";
import {LocalStorageWrapper, RECENT_SEARCH_VALUE_STORAGE_KEY} from "util/LocalStorageWrapper";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import SearchBoxPopup2 from "search2/SearchBoxPopup2";
import {CategoryRepository, ICategory} from "repositories/category/CategoryRepository";
import {CategorySearchResultTab2} from "search2/CategorySearchResultTab2";
import {PostSearchResultTab} from "search2/PostSearchResultTab";
import {FileSearchResultTab} from "search2/FileSearchResultTab";
import {saveAndLoadRecentSearch} from "util/commonUtils";
import styled from "styled-components";
import img_icon_filter from "images/community/icon_filter.svg";
import img_icon_filter_on from "images/community/icon_filter_on.svg";
import {fontFamilyBold, fontFamilyMedium, fontFamilyRegular} from "style/fonts";
import {DOC_TYPE, RANGE_TYPE, RESULT_TYPE, SearchFilter, SORT_TYPE} from "./filter/SearchFilter";
import {PERIOD_TYPE, PRODUCT_TYPE} from "communitypage/common/CommunityFilter";
import {isEqual} from 'lodash-es';
import {connect} from "react-redux";
import {IfLoginInfo} from "models/IfLoginInfo";
import {ACTION_TYPES} from "store/ActionTypes";
import axios from "axios";
import {i18ntrans, tcommona} from "language/i18nkey";
import {langutil} from "language/langutil";
import {getLangSuffix, HelmetTitleAndH1} from "../ctls/common/HelmetTitleAndH1";
import {cookieutil} from "util/cookieutil";

interface Props extends RouteComponentProps<any, any, any> {
  languageService: LanguageService;
  searchRepository2: SearchRepository2;
  ssqDataRepository: SsqDataRepository;
  localStorageWrapper: LocalStorageWrapper;
  categoryRepository: CategoryRepository;
  searchCheckbox: boolean;
  setSearchCheckbox: Function;
  searchInResultCheckbox: boolean;
  setSearchInResultCheckbox: Function;
  loginInfo: IfLoginInfo;
  setLoginInfo;
}


interface State {
  searchInput: any,
  searchPage: any,
  searchCategoryResult: INewCategorySearchResultItem[],
  searchPostResult: IPostSearchResultItem[],
  searchFileResult: IFileSearchResultItem[],
  searchCheckbox: boolean,
  searchInResult: boolean
  recentSearchInputs: string[] | undefined
  countAllSearchResult: ICountAllSearchResult
  searchTabIndices: ISearchTabIndices
  selectedTabIndex: number
  selectedTabType: string
  isMounted: boolean
  isCategorySearchCompleted: boolean
  isPostSearchCompleted: boolean
  isFileSearchCompleted: boolean
  isCountSearchCompleted: boolean
  searchParam: ISrchParam
  speller: string;
  isFilterOpen: boolean;
  resetFilter: boolean;
  isTabsLoaded: {
    product: boolean,
    document: boolean,
    file: boolean,
  }
}

interface ISrchParam {
  resultType: string;
  sortType: string;
  prodType: ICategory;
  periodType: string;
  tagType: [],
  docType: string;
  rangeType: string;
}

export const TabType = Object.freeze({
  ALL: "ALL",
  CATEGORY: "CATEGORY",
  POST: "POST",
  FILE: "FILE"
});

// Not Tested, Just for Test
class AllSearchPage2 extends Component<Props, State> {
  private readonly searchInputRef: React.RefObject<HTMLInputElement>;

  constructor(props: Props) {
    super(props);

    this.searchInputRef = React.createRef();
    this.state = {
      searchInput: new URLSearchParams(this.props.location.search).get("searchInput"),
      speller: new URLSearchParams(this.props.location.search).get("alt"),
      searchPage: 0,
      searchCategoryResult: [],
      searchPostResult: [],
      searchFileResult: [],
      searchCheckbox: true,
      searchInResult: false,
      recentSearchInputs: this.props.localStorageWrapper?.getItem(RECENT_SEARCH_VALUE_STORAGE_KEY)?.split(",").reverse(),
      countAllSearchResult: emptyCountAllSearchResult,
      searchTabIndices: {
        categoryTabIdx: 1,
        postTabIdx: 2,
        fileTabIdx: 3
      },
      selectedTabIndex: 0,
      selectedTabType: TabType.ALL,
      isMounted: false,
      isCategorySearchCompleted: false,
      isPostSearchCompleted: false,
      isFileSearchCompleted: false,
      isCountSearchCompleted: false,
      searchParam: {
        resultType: RESULT_TYPE.ALL_RESULTS,
        sortType: SORT_TYPE.ACCURACY,
        prodType: PRODUCT_TYPE.DEFAULT,
        periodType: PERIOD_TYPE.DEFAULT,
        tagType: [],
        docType: DOC_TYPE.DEFAULT,
        rangeType: RANGE_TYPE.DEFAULT
      },
      isFilterOpen: false,
      resetFilter: false,
      isTabsLoaded: {
        file: false,
        document: false,
        product: false,
      }
    };
  }

  async componentDidMount() {
    if (!langutil.isCountryLangUrl()) {
      document.location.href = langutil.getCountryLangUrl(this.props.languageService.getLanguage());
      return;
    }

    const res = await axios.get('/api/guest/loginInfo');
    if (res?.data) this.props.setLoginInfo(res.data);
    await this.loadSearchResult();
    this.searchInputRef.current?.focus();
    this.setState({
      isMounted: true
    });
  }

  async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (prevProps.location.search !== this.props.location.search) {
      this.setState({searchInput: decodeURIComponent(this.props.location.search.split('=')[1])});
    }
    if (prevState.searchInput !== this.state.searchInput) {
      await this.loadSearchResult();
    }

    if (!isEqual(prevState.countAllSearchResult, this.state.countAllSearchResult)) {
      if (this.state.selectedTabType === TabType.FILE && this.state.countAllSearchResult.countOfSearchedFileItem === 0) {
        this.setState({selectedTabIndex: 0, selectedTabType: TabType.ALL});
      }
      if (this.state.selectedTabType === TabType.POST && this.state.countAllSearchResult.countOfSearchedPostItem === 0) {
        this.setState({selectedTabIndex: 0, selectedTabType: TabType.ALL});
      }
      if (this.state.selectedTabType === TabType.CATEGORY && this.state.countAllSearchResult.countOfSearchedCategoryItem === 0) {
        this.setState({selectedTabIndex: 0, selectedTabType: TabType.ALL});
      }
    }

  }

  async loadSearchResult() {
    if (cookieutil.isAcceptFunctionConsentCookie(this.props.languageService.lang()))
      await this.saveRecentKeywordToLocalStorage();
  }

  getTranslatedText(key: string): string {
    this.props.languageService.setNamespace("I18N_NAMESPACE_ALL_SEARCH_PAGE");
    return this.props.languageService.getTranslationByKey(key) || "";
  }

  async saveRecentKeywordToLocalStorage() {
    if (cookieutil.isAcceptFunctionConsentCookie(this.props.languageService.lang())) {
      this.setState({
        recentSearchInputs: saveAndLoadRecentSearch(
          this.props.localStorageWrapper, this.state.searchInput
        )
      });
    }
  }

  setSearchParam(param: ISrchParam) {
    this.setState({searchParam: param});
  };

  countEntireResult() {
    return Math.max(this.state.countAllSearchResult.countOfSearchedCategoryItem +
      this.state.countAllSearchResult.countOfSearchedPostItem +
      this.state.countAllSearchResult.countOfSearchedFileItem, 0);
  }

  isSearchResultEmpty() {
    return (
      this.state.countAllSearchResult.countOfSearchedPostItem === 0
      && this.state.countAllSearchResult.countOfSearchedCategoryItem === 0
      && this.state.countAllSearchResult.countOfSearchedFileItem === 0
    );
  }

  renderViewMoreInAllTab(searchResultCount: number, viewMoreKeyName: string, tabKey: string, tabType: string) {
    return (<div onClick={() => {
      const selectedTabIndex = this.state.searchTabIndices[tabKey as keyof object] || 0;
      this.setState({
        selectedTabIndex,
        selectedTabType: tabType
      });
    }}
      className={"view-more"}>
      <span>{this.getTranslatedText(viewMoreKeyName)}</span>
      <img alt={"view_more_icon.svg"}
        src={SsqImages.common.icon.viewMoreIcon()}/>
    </div>);
  }

  setCount(type: string, count: number) {
    if (type === 'category') this.setState({countAllSearchResult: {...this.state.countAllSearchResult, countOfSearchedCategoryItem: count}});
    if (type === 'post') this.setState({countAllSearchResult: {...this.state.countAllSearchResult, countOfSearchedPostItem: count}});
    if (type === 'file') this.setState({countAllSearchResult: {...this.state.countAllSearchResult, countOfSearchedFileItem: count}});
  }

  setLoadState(type: string, state: boolean) {
    if (type === 'document') this.setState({isTabsLoaded: {...this.state.isTabsLoaded, document: state}});
    if (type === 'file') this.setState({isTabsLoaded: {...this.state.isTabsLoaded, file: state}});
    if (type === 'product') this.setState({isTabsLoaded: {...this.state.isTabsLoaded, product: state}});
  }

  renderSearchResult() {
    return <SearchResultContainer tDiscontinue={i18ntrans.admin('I18N_SUBJECT_DISCONTINUE')} className={"container"}
      style={{
        display: `${
          isEqual(this.state.isTabsLoaded, {file: true, product: true, document: true})
            ? '' : 'none'}`
      }}>
      <div className={"tab-area"}>
        <TabItem>
          <Tabs selectedIndex={this.state.selectedTabIndex} onSelect={e => {
            this.setState({selectedTabIndex: e});
          }}>
            <TabStickyContent>
              <div className="left-blur"></div>
              <div className="right-blur"></div>
              <div className="tab-bottom-line">
                <TabList>
                  <Tab onClick={() => this.setState({
                    selectedTabType: TabType.ALL
                  })}>
                    {this.getTranslatedText("I18N_ALL_SEARCH_TAB_ALL")}
                    <span>{this.countEntireResult()}</span>
                  </Tab>
                  <Tab style={{display: `${this.state.countAllSearchResult.countOfSearchedCategoryItem > 0 ? '' : 'none'}`}}
                    onClick={() => this.setState({
                      selectedTabType: TabType.CATEGORY
                    })}>
                    {this.getTranslatedText("I18N_ALL_SEARCH_TAB_CATEGORY")}
                    <span>{this.state.countAllSearchResult.countOfSearchedCategoryItem}</span>
                  </Tab>
                  <Tab style={{display: `${this.state.countAllSearchResult.countOfSearchedPostItem > 0 ? '' : 'none'}`}}
                    onClick={() => this.setState({
                      selectedTabType: TabType.POST
                    })}>
                    {this.getTranslatedText("I18N_ALL_SEARCH_TAB_POST")}
                    <span>{this.state.countAllSearchResult.countOfSearchedPostItem}</span>
                  </Tab>
                  <Tab style={{display: `${this.state.countAllSearchResult.countOfSearchedFileItem > 0 ? '' : 'none'}`}}
                    onClick={() => this.setState({
                      selectedTabType: TabType.FILE
                    })}>
                    {this.getTranslatedText("I18N_ALL_SEARCH_TAB_FILE")}
                    <span>{this.state.countAllSearchResult.countOfSearchedFileItem}</span>
                  </Tab>

                </TabList>
                <div className={"btn-filter-box"}>
                  <button className={`btn-filter ${this.state.isFilterOpen ? 'on' : ''}`} onClick={() => {
                    this.setState({isFilterOpen: !this.state.isFilterOpen});
                  }}></button>
                </div>
              </div>

              <SearchFilter
                loginInfo={this.props.loginInfo}
                languageService={this.props.languageService}
                categoryRepository={this.props.categoryRepository}
                setSrchParam={this.setSearchParam.bind(this)}
                mobileToggleFilter={this.state.isFilterOpen}
                reset={this.state.resetFilter}
              />
            </TabStickyContent>
            {this.isSearchResultEmpty() && this.renderEmptySearchResult()}

            <TabPanel>
              <div className={"All_result"}>
                <div className={"result-area" + (this.state.countAllSearchResult.countOfSearchedPostItem > 0 ? ' border_top' : '')}
                  style={
                    {display: `${this.state.countAllSearchResult.countOfSearchedPostItem > 0 ? '' : 'none'}`}
                  }>
                  <PostSearchResultTab
                    searchRepository={this.props.searchRepository2}
                    getTranslatedText={this.getTranslatedText.bind(this)}
                    languageService={this.props.languageService}
                    searchInput={this.state.searchInput}
                    setCount={this.setCount.bind(this)}
                    isDisplayNextPageButton={false}
                    srchParam={this.state.searchParam}
                    postInitCount={this.state.countAllSearchResult.countOfSearchedPostItem}
                    setDocument={this.setLoadState.bind(this)}
                  />
                  {this.state.countAllSearchResult.countOfSearchedPostItem > ALL_SEARCH_GET_SIZE && this.renderViewMoreInAllTab(
                    this.state.countAllSearchResult.countOfSearchedPostItem,
                    "I18N_ALL_SEARCH_TAB_POST_VIEW_MORE",
                    "postTabIdx",
                    TabType.POST
                  )}
                </div>
                <div className={"result-area" + (this.state.countAllSearchResult.countOfSearchedFileItem > 0 ? ' border_top' : '')}
                  style={{display: `${this.state.countAllSearchResult.countOfSearchedFileItem > 0 ? '' : 'none'}`}}>
                  <FileSearchResultTab
                    searchRepository={this.props.searchRepository2}
                    ssqDataRepository={this.props.ssqDataRepository}
                    getTranslatedText={this.getTranslatedText.bind(this)}
                    languageService={this.props.languageService}
                    searchInput={this.state.searchInput}
                    setCount={this.setCount.bind(this)}
                    isDisplayNextPageButton={false}
                    srchParam={this.state.searchParam}
                    fileInitCount={this.state.countAllSearchResult.countOfSearchedFileItem}
                    setFile={this.setLoadState.bind(this)}
                  />
                  {this.state.countAllSearchResult.countOfSearchedFileItem > ALL_SEARCH_GET_SIZE && this.renderViewMoreInAllTab(
                    this.state.countAllSearchResult.countOfSearchedFileItem,
                    "I18N_ALL_SEARCH_TAB_FILE_VIEW_MORE",
                    "fileTabIdx",
                    TabType.FILE
                  )}
                </div>
                <div className={"result-area" + (this.state.countAllSearchResult.countOfSearchedCategoryItem > 0 ? ' border_top' : '')}
                  style={{display: `${this.state.countAllSearchResult.countOfSearchedCategoryItem > 0 ? '' : 'none'}`}}>
                  <CategorySearchResultTab2
                    searchRepository={this.props.searchRepository2}
                    getTranslatedText={this.getTranslatedText.bind(this)}
                    languageService={this.props.languageService}
                    searchInput={this.state.searchInput}
                    setCount={this.setCount.bind(this)}
                    isDisplayNextPageButton={false}
                    srchParam={this.state.searchParam}
                    categoryInitCount={this.state.countAllSearchResult.countOfSearchedCategoryItem}
                    setProduct={this.setLoadState.bind(this)}
                  />
                  {
                    this.state.countAllSearchResult.countOfSearchedCategoryItem > ALL_SEARCH_CATEGORY_GET_SIZE && this.renderViewMoreInAllTab(
                      this.state.countAllSearchResult.countOfSearchedCategoryItem,
                      "I18N_ALL_SEARCH_TAB_CATEGORY_VIEW_MORE",
                      "categoryTabIdx",
                      TabType.CATEGORY
                    )}
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className={"result-area"} style={{borderTop: 'none'}}>
                <CategorySearchResultTab2
                  searchRepository={this.props.searchRepository2}
                  getTranslatedText={this.getTranslatedText.bind(this)}
                  languageService={this.props.languageService}
                  searchInput={this.state.searchInput}
                  setCount={this.setCount.bind(this)}
                  isDisplayNextPageButton={true}
                  srchParam={this.state.searchParam}
                  categoryInitCount={this.state.countAllSearchResult.countOfSearchedCategoryItem}
                  setProduct={this.setLoadState.bind(this)}
                />
              </div>
              <div className={"result-area"} style={{display: 'none'}}>
                <PostSearchResultTab
                  searchRepository={this.props.searchRepository2}
                  getTranslatedText={this.getTranslatedText.bind(this)}
                  languageService={this.props.languageService}
                  searchInput={this.state.searchInput}
                  setCount={this.setCount.bind(this)}
                  isDisplayNextPageButton={true}
                  srchParam={this.state.searchParam}
                  postInitCount={this.state.countAllSearchResult.countOfSearchedPostItem}
                  setDocument={this.setLoadState.bind(this)}
                />
              </div>
              <div className={"result-area"} style={{display: 'none'}}>
                <FileSearchResultTab
                  searchRepository={this.props.searchRepository2}
                  ssqDataRepository={this.props.ssqDataRepository}
                  getTranslatedText={this.getTranslatedText.bind(this)}
                  languageService={this.props.languageService}
                  searchInput={this.state.searchInput}
                  setCount={this.setCount.bind(this)}
                  isDisplayNextPageButton={true}
                  srchParam={this.state.searchParam}
                  fileInitCount={this.state.countAllSearchResult.countOfSearchedFileItem}
                  setFile={this.setLoadState.bind(this)}
                />
              </div>
            </TabPanel>
            <TabPanel>
              <div className={"result-area"} style={{display: 'none'}}>
                <CategorySearchResultTab2
                  searchRepository={this.props.searchRepository2}
                  getTranslatedText={this.getTranslatedText.bind(this)}
                  languageService={this.props.languageService}
                  searchInput={this.state.searchInput}
                  setCount={this.setCount.bind(this)}
                  isDisplayNextPageButton={true}
                  srchParam={this.state.searchParam}
                  categoryInitCount={this.state.countAllSearchResult.countOfSearchedCategoryItem}
                  setProduct={this.setLoadState.bind(this)}
                />
              </div>
              <div className={"result-area"} style={{borderTop: 'none'}}>
                <PostSearchResultTab
                  searchRepository={this.props.searchRepository2}
                  getTranslatedText={this.getTranslatedText.bind(this)}
                  languageService={this.props.languageService}
                  searchInput={this.state.searchInput}
                  setCount={this.setCount.bind(this)}
                  isDisplayNextPageButton={true}
                  srchParam={this.state.searchParam}
                  postInitCount={this.state.countAllSearchResult.countOfSearchedPostItem}
                  setDocument={this.setLoadState.bind(this)}
                />
              </div>
              <div className={"result-area"} style={{display: 'none'}}>
                <FileSearchResultTab
                  searchRepository={this.props.searchRepository2}
                  ssqDataRepository={this.props.ssqDataRepository}
                  getTranslatedText={this.getTranslatedText.bind(this)}
                  languageService={this.props.languageService}
                  searchInput={this.state.searchInput}
                  setCount={this.setCount.bind(this)}
                  isDisplayNextPageButton={true}
                  srchParam={this.state.searchParam}
                  fileInitCount={this.state.countAllSearchResult.countOfSearchedFileItem}
                  setFile={this.setLoadState.bind(this)}
                />
              </div>
            </TabPanel>
            <TabPanel>
              <div className={"result-area"} style={{display: 'none'}}>
                <CategorySearchResultTab2
                  searchRepository={this.props.searchRepository2}
                  getTranslatedText={this.getTranslatedText.bind(this)}
                  languageService={this.props.languageService}
                  searchInput={this.state.searchInput}
                  setCount={this.setCount.bind(this)}
                  isDisplayNextPageButton={true}
                  srchParam={this.state.searchParam}
                  categoryInitCount={this.state.countAllSearchResult.countOfSearchedCategoryItem}
                  setProduct={this.setLoadState.bind(this)}
                />
              </div>
              <div className={"result-area"} style={{display: 'none'}}>
                <PostSearchResultTab
                  searchRepository={this.props.searchRepository2}
                  getTranslatedText={this.getTranslatedText.bind(this)}
                  languageService={this.props.languageService}
                  searchInput={this.state.searchInput}
                  setCount={this.setCount.bind(this)}
                  isDisplayNextPageButton={true}
                  srchParam={this.state.searchParam}
                  postInitCount={this.state.countAllSearchResult.countOfSearchedPostItem}
                  setDocument={this.setLoadState.bind(this)}
                />
              </div>
              <div className={"result-area"} style={{borderTop: 'none'}}>
                <FileSearchResultTab
                  searchRepository={this.props.searchRepository2}
                  ssqDataRepository={this.props.ssqDataRepository}
                  getTranslatedText={this.getTranslatedText.bind(this)}
                  languageService={this.props.languageService}
                  searchInput={this.state.searchInput}
                  setCount={this.setCount.bind(this)}
                  isDisplayNextPageButton={true}
                  srchParam={this.state.searchParam}
                  fileInitCount={this.state.countAllSearchResult.countOfSearchedFileItem}
                  setFile={this.setLoadState.bind(this)}
                />
              </div>
            </TabPanel>
          </Tabs>
        </TabItem>
      </div>
    </SearchResultContainer>;
  }

  renderEmptySearchResult() {
    return <ErrorpageWrap>
      <div className={"Errorpage"}>
        <div className={"container"}>
          <img alt={"error_empty.svg"} src={SsqImages.common.icon.emptySearchResult()}/>
          <p className={"error-tit"}>{this.getTranslatedText("I18N_NO_SEARCH_RESULT")}</p>
          <p className={"error-txt"}>{this.getTranslatedText("I18N_NO_SEARCH_RESULT_NOTICE")}</p>
        </div>
        {!isEqual(this.state.searchParam, {
          resultType: RESULT_TYPE.ALL_RESULTS,
          sortType: SORT_TYPE.ACCURACY,
          prodType: PRODUCT_TYPE.DEFAULT,
          periodType: PERIOD_TYPE.DEFAULT,
          tagType: [],
          docType: DOC_TYPE.DEFAULT,
          rangeType: RANGE_TYPE.DEFAULT
        }) && <button className={"btn-option-init"} onClick={() => {
          this.setState({resetFilter: !this.state.resetFilter});
        }}> {this.getTranslatedText("I18N_SEARCH_RESET")}</button>}
      </div>
    </ErrorpageWrap>;
  }

  render() {
    return (
      <>
        <HelmetTitleAndH1 title={tcommona('I18N_COMMON_TIT_SEARCH', [], [getLangSuffix()])}/>
        <AllSearchPageContainer className={"All-Search-Wrap"}>
          <TitleStickyContent>
            <TitleBarContainer>

              <TitleBarContents className={"container"}>
                <TitleBarItem><a
                  href={"/"}>{this.getTranslatedText("I18N_ALL_SEARCH_TITLE_MAIN")}</a></TitleBarItem>
                <TitleBarItem
                  className="selected">{this.getTranslatedText("I18N_ALL_SEARCH_TITLE_ALL")}</TitleBarItem>
              </TitleBarContents>

            </TitleBarContainer>
          </TitleStickyContent>
          <SearchBoxPopup2
            searchRepository2={this.props.searchRepository2}
            languageService={this.props.languageService}
            categoryRepository={this.props.categoryRepository}
            searchInput={this.state.searchInput}
            localStorageWrapper={this.props.localStorageWrapper}
            searchCheckbox={this.props.searchCheckbox}
            setSearchCheckbox={this.props.setSearchCheckbox}
            searchInResultCheckbox={this.props.searchInResultCheckbox}
            setSearchInResultCheckbox={this.props.setSearchInResultCheckbox}
            isAllSearchPage={true}
            speller={this.state.speller}
          />

          {
            this.state.isMounted && this.renderSearchResult()
          }
        </AllSearchPageContainer>
      </>
    );
  }
}

export default withRouter(connect(
  (state: any) => ({
    loginInfo: state.main.loginInfo,
  }),

  dispatch => ({
    setLoginInfo: (info: IfLoginInfo) => dispatch({type: ACTION_TYPES.MAIN.LOGIN_INFO, payload: info}),
  }))(AllSearchPage2));

const TabStickyContent = styled.div`

  @media screen and (max-width: 764px) {
    position: sticky;
    top: 149px;
    background: #fff;
    z-index: 9;
  }

`;

const AllSearchPageContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  background: #EEF1F6;

  font-size: 2rem;
  overflow-x: hidden;
  @media screen and (max-width: 764px) {
    overflow-x: initial;
    display: block;
  }
`;

const TitleStickyContent = styled.div`

  width: 100%;

  @media screen and (max-width: 764px) {
    position: sticky;
    top: 54px;
    z-index: 2;
  }

`;


const SearchResultContainer = styled.div<{ tDiscontinue: string }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  width: 120rem;
  padding: 3.2rem 0;
  background: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 1;
  min-height: 56rem;

  .react-tabs__tab-list {
    margin: 0 3.2rem;

    span {
      color: #407EDB;
      font-size: 1.2rem;
      margin-left: 0.8rem;
    }
  }

  .tab-area {
    width: 100%;
  }

  .result-area.border_top {
    border-bottom: solid 4px #EEF1F6;

  }

  .border_top:last-of-type {
    border-bottom: none;
  }

  .result-area:last-child {
    border-bottom: none;
  }

  .All_result {
    > div.border_top:last-child {
      border-bottom: none;
    }

    > div.border_top:last-of-type {
      border-bottom: none;
    }
  }

  .result-area {
    padding: 3.2rem;

    //+ .result-area {
    //  border-top: solid 4px #EEF1F6;
    //}


    .result-title {
      font-size: 1.4rem;
      margin-bottom: 2.4rem;

      span {
        color: #407EDB;
        font-size: 1.2rem;
        margin-left: 0.8rem;
      }
    }

    .result-item {
      .search_highlight {
        background: linear-gradient(to top, #FFFAA0 50%, transparent 50%) !important;
        font-weight: initial;
      }

      span.read {
        b {
          color: #407EDB;
          font-weight: inherit;
          margin-left: .4rem;
        }
      }

      span + span:before {
        content: '';
        display: inline-block;
        width: 1px;
        height: 15px;
        background: #C7D6EA;
        vertical-align: middle;
        margin: 0 4px
      }

      + .result-item {
        margin-top: 2.2rem;
        padding-top: 1.8rem;
        border-top: solid 1px #EEF1F6;
      }

      .result-item-tit {
        .category_name {
          display: inline-block !important;
          cursor: pointer;
        }

        .tit {
          color: #407EDB;
          font-size: 1.9rem;
          ${fontFamilyBold};
          display: flex;

          span {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            cursor: pointer;
          }

          .level {
            display: inline-block;
            background: #7783A1;
            color: #fff;
            border-radius: 16px;
            padding: 0 0.8rem;
            //width: 4.8rem;
            height: 1.8rem;
            line-height: 1.8rem;
            //font-weight: bold;
            font-size: 9px;
            text-align: center;
            vertical-align: middle;
            //margin: 0 .4rem 0 1rem;
            margin-left: .6rem;
            width: max-content;
          }

          .partner {
            display: inline-block;
            background: #F4B209;
            color: rgb(255, 255, 255);
            border-radius: 16px;
            //width: 4.8rem;
            padding: 0 0.8rem;
            height: 1.6rem;
            line-height: 1.6rem;
            font-size: 9px;
            font-weight: bold;
            text-align: center;
            vertical-align: middle;
            margin-left: .6rem;
            width: max-content;
          }
        }
      }

      .result-item-info {
        font-size: 1.3rem;
        margin-top: 1.2rem;
        overflow: hidden;

        .img-wrap {
          width: 92px;
          height: 92px;
          line-height: 92px;
          background: #F6F8FB;
          border: 1px solid #EEF1F5;
          border-radius: 4px;
          margin-right: 1.2rem;
          cursor: pointer;
          float: left;
          position: relative;
          overflow: hidden;


          img {
            max-width: 100%;
            max-height: 100%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }

          &.sold-out {

            img {
              opacity: .3;
            }

            :before {
              content: "${p => p.tDiscontinue || "단종"}";
              min-width: 3.2rem;
              height: 1.7rem;
              line-height: 1.5rem;
              font-size: .8rem;
              ${fontFamilyMedium};
              position: absolute;
              top: .4rem;
              left: .4rem;
              z-index: 2;
              color: #7783A1;
              background: rgba(119, 131, 161, 0.1);
              text-align: center;
              border-radius: 2rem;
              padding: 0 0.3rem;
              box-sizing: border-box;
              white-space: nowrap;
            }

          }
        }

        .desc-wrap > span {
          display: -webkit-box;
          word-wrap: break-word;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
          line-height: 1.7;
          ${fontFamilyRegular}
        }

        .txt_bt:not(.down_bt) {
          display: -webkit-box !important;
          word-wrap: break-word;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .txt_bt {
          color: #7783A1;
          font-size: 1.2rem;
          cursor: initial;

          ${fontFamilyRegular}
          span {
            vertical-align: middle;
            display: inline-block;

            > span {
              vertical-align: top;
            }
          }

          .line {
            width: 1px;
            height: 15px;
            background: #C7D6EA;
            vertical-align: middle;
            margin: 0 4px;
          }

          img {
            vertical-align: middle;
            margin-right: .7rem;
            cursor: pointer;
          }

          .view-detail {
            margin-left: 1.6rem;
            text-decoration: none;
            color: #407EDB;
            cursor: pointer;
            display: inline-block;
            vertical-align: middle;

            img {
              margin: 0;
            }
          }
        }

        .down_bt {
          > span {
            float: none !important;
            vertical-align: middle !important;
            cursor: initial !important;
            line-height: 2.4rem;
          }
        }

        .tit-txt {
          display: block;
          color: #7783A1;
          font-size: 1.2rem;
          margin-top: 1rem;
          ${fontFamilyRegular};
        }

        .tag-txt {
          display: block;
          color: #7783A1;
          font-size: 1.2rem;
          margin-top: 1rem;
          ${fontFamilyRegular};

          span {
            :before {
              display: none
            }
          }
        }

        .related_bt {

          .comma {
            margin-right: .4rem;
          }


          span {
            :before {
              display: none
            }
          }
        }

        > .down_bt {
          display: none
        }
      }

      .result-item-img-info {
        .txt-wrap {
          float: right;
          width: calc(100% - 115px);
        }
      }
    }
  }

  .view-more {
    font-size: 1.2rem;
    color: #407EDB;
    text-align: center;
    cursor: pointer;

    span {
      vertical-align: middle
    }

    img {
      width: 24px;
      height: 24px;
      margin-left: .8rem;
      vertical-align: middle;
      transform: rotate(90deg);
    }
  }

  .All_result .view-more {
    text-align: right;

    img {
      transform: none;
    }
  }

  .result-area:last-child {
    //padding: 3.2rem 3.2rem 0
  }

  .btn-filter-box {
    display: none;
  }

  .btn-filter {
    width: 3.2rem;
    height: 3.2rem;
    background-image: url(${img_icon_filter});
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 4px;
    //display: none;
    flex-shrink: 0;
    vertical-align: middle;
  }


  .btn-filter.on {
    background: #D9E5F7;
    background-image: url(${img_icon_filter_on});
    background-repeat: no-repeat;
    background-position: center;
  }


  .left-blur, .right-blur {
    display: none;
  }

  .btn-option-init {
    background: #407EDB;
    color: #fff;
    margin-top: 4rem;
    width: 32rem;
    height: 4.8rem;
    line-height: 4.8rem;
    font-size: 1.6rem;
    ${fontFamilyBold};
    border-radius: 4rem;
  }

  @media screen and (max-width: 1199px) {
    padding: 0 0 3.2rem 0;
    .react-tabs__tab-list {
      margin: auto;
      padding-top: 0.8rem;
      width: calc(100% - 4rem);
    }
  }
  @media screen and (max-width: 764px) {
    padding: 0 0 16px;
    .react-tabs__tab {
      //min-width: 8rem;
      margin: 0 1.5rem;
      padding: 0 .8rem;
    }

    .result-area {
      padding: 16px !important;

      :last-child {
        padding: 16px 16px 0 16px !important;
      }
    }

    .result-item-tit {
      position: relative;
    }

    .down_bt {
      display: none !important;

      + .tit-txt {
        margin-top: 0 !important;
      }
    }

    .result-item-info {
      position: relative;

      .img-wrap {
        width: 90px !important;
        height: 90px !important;
        margin-right: 1rem !important;
      }

      .txt-wrap {
        .down_bt {
          display: none !important;

          + .tit-txt {
            margin-top: 0 !important;
          }
        }
      }

      .desc-wrap {
        display: inline-block;
        max-height: 80px;
        overflow: hidden;
      }

      .desc-wrap span {
        -webkit-line-clamp: 3 !important;
        font-size: 12px;
        line-height: 1.5 !important;
      }

      .tit-txt {
        margin-top: 0 !important;
      }

      .txt_bt {
        clear: both;

        + .tit-txt {
          margin-top: .5rem !important;
        }
      }

      .down_bt {
        display: block !important;
        padding-top: .8rem;

        > span {
          float: none !important;
        }
      }
    }

    .result-item-img-info {
      .txt-wrap {
        width: calc(100% - 100px) !important;
      }
    }

    .All_result .view-more {
      margin-top: 0;
    }

    .tab-bottom-line {
      border-bottom: 1px solid #90A0B6;
    }

    .react-tabs__tab-list {
      border-bottom: none;
      margin: 0;
    }

    .btn-filter-box {
      display: inline-block;
      position: absolute;
      top: 1rem;
      right: .8rem;
    }

    .left-blur {
      display: block;
      position: absolute;
      width: 2rem;
      height: 4rem;
      left: 0;
      top: 3px;
      background: linear-gradient(to right, #fff 30%, rgba(255, 255, 255, 0));
      z-index: 2;
    }

    .right-blur {
      display: block;
      position: absolute;
      width: 2rem;
      height: 4rem;
      right: 4rem;
      top: 3px;
      background: linear-gradient(to left, #fff 30%, rgba(255, 255, 255, 0));
      z-index: 2;
    }

    .inquiry-box .right-blur {
      right: 0;
    }
  }
`;
